interface DeviceProgressBarProps {
  deviceIndex: number;
  progress?: number;
  disabled?: boolean;
  muted?: boolean; // Device is muted (inactive) - show darker progress bar
  transitionDurationMs?: number; // Duration to next beat in milliseconds
}

export default function DeviceProgressBar({
  deviceIndex,
  progress = 0,
  disabled = false,
  muted = false,
  transitionDurationMs = 0, // Static fills: instant updates on beat boundaries
}: DeviceProgressBarProps) {
  // When disabled, always show 0% progress
  // When muted, still show progress (pattern continues playing)
  const displayProgress = disabled ? 0 : progress;

  return (
    <div
      role="progressbar"
      aria-label={`Device ${deviceIndex} playback progress`}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={displayProgress}
      className="relative w-full h-1.5 bg-gray-800 overflow-hidden"
    >
      <div
        data-testid="progress-fill"
        className={`h-full ${
          disabled ? 'bg-purple-800 opacity-30' :
          muted ? 'bg-purple-900 opacity-50' :
          'bg-purple-800'
        }`}
        style={{
          width: `${displayProgress}%`,
          transitionDuration: `${transitionDurationMs}ms`
        }}
      />
    </div>
  );
}
